<template>
    <div id="content">
        <div class="admin-card purchase-result">
            <div class="purchase-icon" :class="state">
                <i class="bi" :class="iconClass"></i>
            </div>
            <h1 class="purchase-title">{{ title }}</h1>
            <p class="purchase-message">{{ message }}</p>
            <div class="purchase-actions">
                <router-link to="/plans-table" class="btn-purple">
                    <i class="bi bi-list-ul"></i>
                    <span>{{ $t('plans.purchaseSuccess.backToPlans') }}</span>
                </router-link>
                <router-link v-if="state === 'success'" to="/cabinet" class="btn-ghost">
                    <span>{{ $t('plans.purchaseSuccess.toCabinet') }}</span>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
const POLL_INTERVAL_MS = 1500
const MAX_POLLS = 10

export default {
    data: () => ({
        state: 'verifying', // 'verifying' | 'success' | 'pending'
        polls: 0,
        timer: null
    }),
    computed: {
        title() {
            if(this.state === 'verifying') return this.$t('plans.purchaseSuccess.verifyingTitle')
            if(this.state === 'success') return this.$t('plans.purchaseSuccess.successTitle')
            return this.$t('plans.purchaseSuccess.pendingTitle')
        },
        message() {
            if(this.state === 'verifying') return this.$t('plans.purchaseSuccess.verifyingMessage')
            if(this.state === 'success') return this.$t('plans.purchaseSuccess.successMessage')
            return this.$t('plans.purchaseSuccess.pendingMessage')
        },
        iconClass() {
            if(this.state === 'verifying') return 'bi-hourglass-split'
            if(this.state === 'success') return 'bi-check-circle-fill'
            return 'bi-clock-history'
        }
    },
    mounted() {
        const id = this.$route.query.t
        if(!id) {
            this.state = 'pending'
            return
        }
        this.poll(id)
    },
    beforeUnmount() {
        if(this.timer) clearTimeout(this.timer)
    },
    methods: {
        async poll(id) {
            try {
                const r = await this.$api.getTransactionStatus(id)
                if(r?.result === 'SUCCESS' && r.data?.paid) {
                    this.state = 'success'
                    return
                }
            } catch (e) {
                // swallow — keep polling
            }
            this.polls += 1
            if(this.polls >= MAX_POLLS) {
                this.state = 'pending'
                return
            }
            this.timer = setTimeout(() => this.poll(id), POLL_INTERVAL_MS)
        }
    }
}
</script>

<style scoped>
.purchase-result {
    max-width: 520px;
    margin: 60px auto 0;
    padding: 36px 28px;
    text-align: center;
}
.purchase-icon {
    font-size: 56px;
    line-height: 1;
    margin-bottom: 18px;
}
.purchase-icon.verifying { color: #6d28d9; }
.purchase-icon.success { color: #16a34a; }
.purchase-icon.pending { color: #d97706; }
.purchase-title {
    font-size: 22px;
    font-weight: 700;
    color: #0f172a;
    margin: 0 0 10px 0;
}
.purchase-message {
    font-size: 15px;
    color: #475569;
    margin: 0 0 24px 0;
}
.purchase-actions {
    display: inline-flex;
    gap: 10px;
    justify-content: center;
    flex-wrap: wrap;
}
</style>
